import { render } from "./UserPopUp.vue?vue&type=template&id=33c5114c"
import script from "./UserPopUp.vue?vue&type=script&lang=js"
export * from "./UserPopUp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__